<template>

  <div id="app">
    <div >
      <search-bar  ref="searchBarComponent" @searchBarHeight="getSearchBarHeight">
         <!-- <div slot="search-tool">
              <el-button class="item-btn c-btn-sub" @click="clearQuery">重置</el-button>
          </div> -->
          <div slot="search-cont">

              <div class="item" >
                <div class="item-label">关键词搜索</div>
                <div style="width: 300px;" >
                  <el-input placeholder="请输入内容" v-model="key" class="input-with-select" size="small" @keyup.enter.native='searchResume'>
                    <el-select v-model="key_type" slot="prepend" placeholder="请选择" @change="selectChange" style="width: 130px" size="small">
                      <el-option label="合作人力资源公司" value="1"></el-option>
                      <el-option label="合作工厂" value="2"></el-option>
                    </el-select>
                    <el-button slot="append" icon="el-icon-search" @click='searchResume' size="small"></el-button>
                  </el-input>
                </div>
              </div>

              <!--  操作按钮 start -->
                <div class="item">
                  <el-button class="item-btn" type="primary" @click="getCompany">查询</el-button>
                  <el-button class="item-btn reset-btn" @click="clearQuery">重置</el-button>
                </div>
              <!--  操作按钮 end -->

          </div>

      </search-bar>

    <div class="l-panel">
      <div class="panel-body">
        <el-table class="l-table" :data="companyList" stripe style="width: 100%;" @selection-change="handleSelectionChange" size="mini">
            <el-table-column prop="cooperation_enterprise_name" label="合作人力资源公司" align="left"> </el-table-column>
            <el-table-column prop="companyname" label="合作工厂" align="center"> </el-table-column>
            <el-table-column prop="addtime" label="添加时间" align="center"> </el-table-column>
            <el-table-column  prop="date" label="操作" align="center">
               <template slot-scope="{row}">
                 <div class="btn">
                 <!-- <el-button type="primary" plain  @click="handleEdit(row.uid)" size='mini'>借资</el-button> -->
                 <el-button type="primary" plain  size="mini" @click='handleDele(row.id)'>删除</el-button>
                 </div>
               </template>
            </el-table-column>

          </el-table>

          <div class="c-table-pager">
            <el-pagination  @current-change="handleCurrentChange" :total="total"></el-pagination>
          </div>
      </div>
    </div>




    </div>



  </div>

</template>

<script>
  import { WebUrl } from '@/api/index';
  import Message from '@/utils/message.js';
  export default{
    data:function(){
      return {
      companyList:[],
      key:'',   //关键字搜索
      key_type:'', //关键字类型：
      page:1,   //页码
      total:1,
      myHeaders:{},
      fileList:[],
      host:process.env.API_ROOT,
      id:'',
      yoes2: {

      },
      uploadData:{type:'zp'}

      }
    },
    activated() {
    this.getCompany()
    let date = new Date()
    this.year = date.getFullYear()
    // 获取token
    let access_token = this.$store.state.token;
    // 获取token
    let token_type = this.$store.state.token_type;
    this.myHeaders = { authorization: token_type + " " + access_token };
    },
    created() {
          this.$nextTick(() => {
            document.onselectstart = new Function("event.returnValue=false");
          });
    },
    methods:{
      handleEdit(id){
        if(id){
          var ids=id
        }else{
          var ids = ''
        }
        this.$router.push({
          path:'/oacompanyEdit?id='+ids
        })
      },
      clearQuery(){
        this.key = ''
        this.key_type = ''
        this.getCompany()
      },
      // 获取操作栏展开收缩之后的高度
      getSearchBarHeight(val) {
          let sHeight = val;
          let fHeight = this.$refs.pageTableFilter ? this.$refs.pageTableFilter.clientHeight : 0;
          this.tableInitHeight = this.$util.setTableHeight(sHeight, fHeight);
      },
        //类型查找
        searchResume(){
          if(!this.key_type){return Message.warning('请选择搜索类型')}
          this.page = 1
          this.getCompany()
        },
        //全部列表
        getCompany(){
          this.gets('enterprisecooperation/cooperationCompanylist',
          {key:this.key,key_type:this.key_type,page:this.page })
          .then(res=>{
            this.companyList = res.data.data.list;
            this.total = res.data.data.total
            })
        },
        resumeTypeChange(){ this.selectId = []},

        changeDialogs(val){

        },
        //翻页
        handleCurrentChange(val){
        this.page = val
          this.getCompany()

        },
        selectChange(){this.$forceUpdate()},

       handleSelectionChange(val){
         let array = []
         array = val.map((item)=>{array.push(item.id);return array})
         this.selectId = array[array.length-1]
         //debugger
         //console.log(this.email)
       },

         //删除借支
           handleDele(id){
                this.$confirm("此操作将删除此条数据, 是否继续?", "提示", {
                 confirmButtonText: "确定",
                 cancelButtonText: "取消",
                 type: "warning",
                 center: true,
            }).then(() => {
              this.post("enterprisecooperation/cooperationStop",{id:id}).then((res) => {
                  if(res.data.code==1){Message.success(res.data.msg)}
                  else{Message.error(res.data.msg)}
                  this.getCompany()
              });
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: "已取消删除",
              });
            });
           },

    }
  }
</script>

<style scoped>
  .content{padding:20px 0px;box-sizing: border-box;width: 100%;}
  .pagination{margin:20px auto;width: 100%;text-align: center;}
  .screen{display: flex;position: relative;}
  .screenList{display: flex;margin: 30px 0 10px;}
  .screenList .listItem{margin-right:40px;display: flex;height: 40px;align-items: center;}
  .screen>>>.el-select{width: 100px;}
  .screenList>>>.el-select{width: 150px;}
  .screenTime{display: flex;margin: 20px 0;}
  .screenTime .items1{display: flex;margin-right: 30px;height: 45px;align-items: center;}
  .remarks{margin: 10px 0;}
  .remarks .title{margin-bottom: 10px;}
  .funtion{margin: 20px 0;background-color: #fff;padding: 20px ;}
  .resumeType{display: flex;height: 45px;align-items: center;font-size: 20px;}
  #app>>>.el-dialog{max-width: 1000px;}
  .btn>.el-button{
    margin: 5px 0;
  }
  .contents{display: flex;}
  .contents .items{margin: 20px;width: 100px;text-align: center;}
</style>



// WEBPACK FOOTER //
// src/view/jobsManage/enterpriseCooperation.vue